export default {
  title_one: 'Statistiche di consegna in aggiornamento per «{{title}}»',
  title_other: 'Statistiche di consegna in aggiornamento per {{count}} campagne',
  subtitle_pending:
    'Apple e Google confermano le ricevute in circa {{minutes}}m {{seconds}}s (intorno alle {{time}}). Le statistiche si aggiorneranno automaticamente.',
  subtitle_ready:
    'Le ricevute dovrebbero essere disponibili. Aggiorna la pagina per vedere i dati di consegna più recenti.',
};
